 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"EmbeddedBracket~minigame-tournament~minigames~organization~profile~rating~tournament~tournament-edit~6e72c67a":"EmbeddedBracket~minigame-tournament~minigames~organization~profile~rating~tournament~tournament-edit~6e72c67a","EmbeddedBracket~tournament~tournament-edit":"EmbeddedBracket~tournament~tournament-edit","EmbeddedBracket":"EmbeddedBracket","organization~tournament-edit":"organization~tournament-edit","tournament-edit":"tournament-edit","main~tournament~tournaments":"main~tournament~tournaments","profile~tournaments":"profile~tournaments","organization~tournaments":"organization~tournaments","tournaments":"tournaments","minigame-tournament":"minigame-tournament","minigames":"minigames","organization~profile~rating~tournament":"organization~profile~rating~tournament","tournament":"tournament","jobfair~profile":"jobfair~profile","profile":"profile","main~rating":"main~rating","rating":"rating","organization":"organization","HubMatch~match":"HubMatch~match","HubMatch":"HubMatch","match":"match","TestGameLink":"TestGameLink","TestRegistrationPage":"TestRegistrationPage","autopayments":"autopayments","inputmask":"inputmask","jobfair":"jobfair","main~news~videos":"main~news~videos","news":"news","videos":"videos","main":"main","minigame":"minigame","team":"team","terms":"terms","wysiwyg":"wysiwyg","MatchHs":"MatchHs","MatchShooters":"MatchShooters"}[chunkId]||chunkId) + "." + {"EmbeddedBracket~minigame-tournament~minigames~organization~profile~rating~tournament~tournament-edit~6e72c67a":"0e069e66","EmbeddedBracket~tournament~tournament-edit":"04d7b760","EmbeddedBracket":"9c243072","organization~tournament-edit":"07f0f344","tournament-edit":"12010ec9","main~tournament~tournaments":"922f64cf","profile~tournaments":"6573831b","organization~tournaments":"1a8a6741","tournaments":"e9b7b55a","minigame-tournament":"93323401","minigames":"8d5efacf","organization~profile~rating~tournament":"e74b6059","tournament":"c6e63571","jobfair~profile":"2219c1bc","profile":"0616a160","main~rating":"31f40d19","rating":"3c88bc89","organization":"4e059525","HubMatch~match":"8a789ba7","HubMatch":"5acbbed6","match":"65ef10d5","TestGameLink":"25bd3826","TestRegistrationPage":"b67e33c1","autopayments":"1544cc82","chunk-2676dba3":"5df728bc","chunk-2d32658a":"1812c366","chunk-7e1d3423":"db271b80","inputmask":"807173df","jobfair":"282441f7","main~news~videos":"24b1ca25","news":"f933bdb7","videos":"a2c71b1f","main":"ed474d52","minigame":"ce51eb82","team":"4d15287b","terms":"585e8848","wysiwyg":"3d52ac39","MatchHs":"8f92c6d0","MatchShooters":"1385006c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"EmbeddedBracket~minigame-tournament~minigames~organization~profile~rating~tournament~tournament-edit~6e72c67a":1,"EmbeddedBracket~tournament~tournament-edit":1,"EmbeddedBracket":1,"organization~tournament-edit":1,"tournament-edit":1,"main~tournament~tournaments":1,"profile~tournaments":1,"organization~tournaments":1,"tournaments":1,"minigame-tournament":1,"minigames":1,"organization~profile~rating~tournament":1,"tournament":1,"jobfair~profile":1,"profile":1,"main~rating":1,"rating":1,"organization":1,"HubMatch~match":1,"HubMatch":1,"match":1,"TestGameLink":1,"TestRegistrationPage":1,"autopayments":1,"chunk-2d32658a":1,"chunk-7e1d3423":1,"jobfair":1,"main~news~videos":1,"news":1,"videos":1,"main":1,"minigame":1,"team":1,"terms":1,"wysiwyg":1,"MatchHs":1,"MatchShooters":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"EmbeddedBracket~minigame-tournament~minigames~organization~profile~rating~tournament~tournament-edit~6e72c67a":"EmbeddedBracket~minigame-tournament~minigames~organization~profile~rating~tournament~tournament-edit~6e72c67a","EmbeddedBracket~tournament~tournament-edit":"EmbeddedBracket~tournament~tournament-edit","EmbeddedBracket":"EmbeddedBracket","organization~tournament-edit":"organization~tournament-edit","tournament-edit":"tournament-edit","main~tournament~tournaments":"main~tournament~tournaments","profile~tournaments":"profile~tournaments","organization~tournaments":"organization~tournaments","tournaments":"tournaments","minigame-tournament":"minigame-tournament","minigames":"minigames","organization~profile~rating~tournament":"organization~profile~rating~tournament","tournament":"tournament","jobfair~profile":"jobfair~profile","profile":"profile","main~rating":"main~rating","rating":"rating","organization":"organization","HubMatch~match":"HubMatch~match","HubMatch":"HubMatch","match":"match","TestGameLink":"TestGameLink","TestRegistrationPage":"TestRegistrationPage","autopayments":"autopayments","inputmask":"inputmask","jobfair":"jobfair","main~news~videos":"main~news~videos","news":"news","videos":"videos","main":"main","minigame":"minigame","team":"team","terms":"terms","wysiwyg":"wysiwyg","MatchHs":"MatchHs","MatchShooters":"MatchShooters"}[chunkId]||chunkId) + "." + {"EmbeddedBracket~minigame-tournament~minigames~organization~profile~rating~tournament~tournament-edit~6e72c67a":"da07769a","EmbeddedBracket~tournament~tournament-edit":"1434888f","EmbeddedBracket":"cfc48a9d","organization~tournament-edit":"567f4451","tournament-edit":"3bc0dd0d","main~tournament~tournaments":"fbbbaf84","profile~tournaments":"b50a5c46","organization~tournaments":"47ce9821","tournaments":"d6a7e0cf","minigame-tournament":"e1823e82","minigames":"8c07f9eb","organization~profile~rating~tournament":"e16a4ab7","tournament":"673701c6","jobfair~profile":"41c444af","profile":"452e205c","main~rating":"ea3943ba","rating":"08c58613","organization":"5436ce4c","HubMatch~match":"4b0b4c45","HubMatch":"1a1eb86f","match":"3083a560","TestGameLink":"7edc8e86","TestRegistrationPage":"53a3aedf","autopayments":"27261548","chunk-2676dba3":"31d6cfe0","chunk-2d32658a":"7029de8d","chunk-7e1d3423":"5a9fe9f1","inputmask":"31d6cfe0","jobfair":"e45bb32e","main~news~videos":"cfaa447d","news":"7f5ee565","videos":"69a2c2f9","main":"262704b9","minigame":"517e7cfa","team":"b3ca1ba2","terms":"28974f17","wysiwyg":"528be7c7","MatchHs":"65802068","MatchShooters":"7c5a573a"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-pvp.vkplay.ru/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
